// plugins/measure/MeasurePlugin.ts

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../store/store";
import { useMapContext } from "../../core/MapContext";
import { createMeasureTool } from "./measureToolFactory";

export const MeasurePluginComponent = () => {
  const { mode, segments } = useSelector((state: RootState) => state.measure);

  const dispatch = useDispatch();

  const { mapType, mapInstance } = useMapContext();

  useEffect(() => {
    if (!mapInstance) return;

    //if (mode === "NONE") return;

    const tool = createMeasureTool(mapInstance, mapType, mode, (segments || [])?.slice(), dispatch);
    tool.activate();

    return () => {
      tool.deactivate();
    };
  }, [mode, mapInstance, segments]);

  return null;
};
